export default __webpack_public_path__ + "static/media/logo.bcaef61a.svg";